import { render, staticRenderFns } from "./guest-reviews.vue?vue&type=template&id=49e1dc95&scoped=true&"
import script from "./guest-reviews.vue?vue&type=script&lang=js&"
export * from "./guest-reviews.vue?vue&type=script&lang=js&"
import style0 from "./guest-reviews.vue?vue&type=style&index=0&id=49e1dc95&scoped=true&lang=css&"
import style1 from "./guest-reviews.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e1dc95",
  null
  
)

export default component.exports